import { getClient } from 'lane-shared/apollo';
import {
  AddProductToChargeDetails,
  ChargeDetails,
} from 'lane-shared/domains/billingPayments/types';
import {
  GroupType,
  CreateRecurringChargeRequest,
  ExternalEntityType,
  ExternalActorType,
  RecurrenceType,
} from 'graphql-query-contracts';
import { convertToUUID } from 'uuid-encoding';
import {
  currencyToGraphQL,
  convertExternalPayerType,
  convertRecurrenceInterval,
} from 'domains-billing-web-mappers';
import { createRecurringChargeMutationQuery } from './chargesInvoiceQueries';
import { convertProductsToQueryFormat } from './createChargeMutation';

export interface CreateNewChargeDetails extends ChargeDetails {
  channelId: string;
  chargeCreatorUserId: string;
  anyoneCanCancel: boolean;
}

export async function createRecurringChargeMutation(
  chargeDetails: CreateNewChargeDetails,
  products: AddProductToChargeDetails[]
) {
  const {
    invoicee: { _id, type: invoiceeType },
    name,
    description,
    amount,
    currency,
    frequency,
    startDate,
    endDate,
    totalCounts,
    channelId,
    chargeCreatorUserId,
    paymentDueDays,
    anyoneCanCancel,
    invoiceType,
  } = chargeDetails;

  const productItems = convertProductsToQueryFormat(products, channelId);

  await getClient().mutate<
    any,
    { createRecurringChargeRequest: CreateRecurringChargeRequest }
  >({
    mutation: createRecurringChargeMutationQuery,
    variables: {
      createRecurringChargeRequest: {
        charge: {
          name,
          description,
          amount: Number(amount),
          currency: currencyToGraphQL(currency),
          groupId: convertToUUID(channelId),
          groupType: GroupType.GroupTypeActivateChannel,
          externalEntityId: '',
          externalEntityType:
            ExternalEntityType.ExternalEntityTypeActivateUci,
          externalActorId: convertToUUID(chargeCreatorUserId),
          externalActorType:
            ExternalActorType.ExternalActorTypeActivateUser,
          externalPayerId: convertToUUID(_id),
          externalPayerType: convertExternalPayerType(invoiceeType),
          invoiceType,
          metadata: '',
          invoiceDueInDays: paymentDueDays,
          items: productItems,
        },
        recurrenceType: RecurrenceType.RecurrenceTypeCharges,
        recurrenceInterval: convertRecurrenceInterval(frequency),
        startDate: new Date(startDate.toUTCString()),
        totalCounts,
        endDate,
        anyoneCanCancel,
      },
    },
  });
}
